(function () {
    "use strict";

    angular
        .module("forms-widget", [
            "roller-env",
            "roller-wysiwyg",
            "ngSanitize",
            "ngMessages",
            "ngAria",
            "ui.router",
            "ngStorage",
            "rollerFormRenderer",
            "tmh.dynamicLocale",
            "angularLoad"
        ]);

})();

(function () {
    "use strict";

    angular.module('forms-widget')
           .directive("rollerWidget", rollerWidget);

    /** @ngInject */
    function rollerWidget(insideIframe) {
        return {
            restrict: "E",
            transclude: true,
            template: '<div ui-view autoscroll="' + !insideIframe + '"' +
            'style="max-width:710px;margin-left:auto;margin-right:auto;margin-top:' + (!insideIframe ? '50px' : '0') + '"></div>'
        };
    }

})();

(function() {
    "use strict";

    angular
        .module("forms-widget")
        .service("postMessage", postMessage);

    /** @ngInject */
    function postMessage($window, $rootScope) {
        var canPostMessage = angular.isFunction($window.postMessage);
        if(canPostMessage) {
            if (angular.isFunction($window.addEventListener)) {
                $window.addEventListener("message", receiveMessage);
            }
            else {
                $window.attachEvent("onmessage", receiveMessage);
            }
        }

        return function(frame, data, targetOrigin) {
            var target;
            if(!canPostMessage) {
                return;
            }
            if(angular.isString(frame)) {
                target = $window[frame];
            } else if(typeof target !== "undefined") {
                target = frame;
            }
            if(target) {
                target.postMessage(data, targetOrigin || "*");
                $rootScope.$broadcast("postMessage:sent", { frame: frame, data: data, targetOrigin: targetOrigin || "*" });
            }
        };

        function receiveMessage(event) {
            $rootScope.$broadcast("postMessage:received", { data: event.data, origin:event.origin });
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("forms-widget")
        .directive("broadcastHeight", broadcastHeight);

    /** @ngInject */
    function broadcastHeight(postMessage, insideIframe, $log, $timeout) {
        return {
            restrict: "A",
            link: function (scope, element) {

                if (!insideIframe) {
                    return;
                }

                var previousHeight,
                    getHeight = angular.isFunction(element.height) ? getJQueryHeight : getOffsetHeight;

                update();

                function update() {
                    var height = getHeight(),
                        data;

                    if (height !== previousHeight) {
                        previousHeight = height;
                        data = {
                            action: "resize",
                            height: height
                        };
                        postMessage("parent", data, "*");
                    }
                    // Using $timeout instead of scope.$watch
                    // because scope.$watch wasn't reliable
                    $timeout(update, 50);
                }

                function getJQueryHeight() {
                    var height = element.height();
                    return height == 0 ? element.children().first().height() : height;
                }

                function getOffsetHeight() {                    
                    return element[0].offsetHeight || 0;
                }
            }
        };
    }

})();

(function () {
    "use strict";

    angular
        .module("forms-widget")
        .controller("WelcomeController", WelcomeController);

    /** @ngInject */
    function WelcomeController($state, formsService) {
        var vm = this;

        vm.goToForm = function () {
            $state.go('forms.form');
        }

        if (formsService.isFormSubmissionClosed()) {
            vm.errorText = 'Form submissions have closed';
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("forms-widget")
        .service("venueService", venueService);

    /** @ngInject */
    function venueService($http, rollerApiUrl, insideIframe, $document, tmhDynamicLocale, angularLoad, env) {
        var service = {};

        var _countryRestriction = null;
        var _headerImageUrl = null;
        var _doneProbing = false;
        var _hideRollerBranding = false;

        service.hideRollerBranding = function(){
            return _hideRollerBranding;
        }

        service.countryRestriction = function () {
            return _countryRestriction;
        }

        service.headerImageUrl = function () {
            return insideIframe ? null : _headerImageUrl;
        }

        service.localeDataLoaded = false;
        service.probe = function () {
            return $http({
                url: rollerApiUrl + 'account/probe',
                method: "GET"
            }).then(function () {
                _doneProbing = true;
            });
        }

        service.isReady = function () {
            return _doneProbing;
        }

        service.initialise = function () {
            $http({
                url: rollerApiUrl + 'venues/me?tracking=true',
                method: 'GET'
            }).then(function (response) {
                handleVenueStatus(response.data);

                if (response.data.locale) {
                    tmhDynamicLocale.set(response.data.locale.toLowerCase());

                    var momentLocaleFile = response.data.momentLocaleFile;
                    if (!!momentLocaleFile && momentLocaleFile !== 'en') {
                        var momentLocaleScript = env.baseUrls.cdn + '/scripts/moment/' + moment.version + '/locale/' + momentLocaleFile + '.js';

                        angularLoad.loadScript(momentLocaleScript).then(function (response) {
                            moment.locale(momentLocaleFile);
                            service.localeDataLoaded = true;
                        });
                    }
                    else {
                        service.localeDataLoaded = true;
                    }
                }

                _hideRollerBranding = response.data.hideRollerBranding;
                _countryRestriction = response.data.countryCode;

                if (insideIframe) {
                    angular.element('body').css('background-color', 'transparent');
                }
                else {
                    _headerImageUrl = response.data.headerImageUrl;

                    if (response.data.backgroundImageUrl) {
                        angular.element('body').css('background-image', 'url(\'' + response.data.backgroundImageUrl + '\')');
                        angular.element('body').addClass('has-background');
                    }
                }

                var gtmTemplate = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','{0}');";

                _.each(response.data.gtmCodes, function (c) {

                    var s = $document[0].createElement('script');

                    s.innerHTML = gtmTemplate.replace('{0}', c);
                    s.setAttribute('type', 'text/javascript');

                    $document[0].body.appendChild(s);
                });
            }, function () {
                var inactiveVenueRedirect = RollerAppConfig().inactiveVenueRedirect;
                if (inactiveVenueRedirect) {
                    window.location.href = inactiveVenueRedirect + window.location.hash;
                    return;
                }
            });
        }

        function handleVenueStatus(data) {
            if (data.status === 5) {
                $.get(env.baseUrls.cdn + '/assets/pages/404.html', function (html) {
                    document.querySelector('html').innerHTML = html;
                });
            }
        }

        return service;
    }
})();
(function () {
    "use strict";

    angular
        .module("forms-widget")
        .controller("SubmittedController", SubmittedController);

    /** @ngInject */
    function SubmittedController($state, $stateParams, form, isKioskMode) {
        var vm = this;

        vm.isKiosk = isKioskMode;

        if (isKioskMode) {
            vm.goToKioskHome = goToKioskHome;
        }

        activate();

        function activate() {
            vm.postSubmissionPage = _.find(form.pages, function (p) {
                return p.enabledWhen === 'Submitted' && p.contentHtml;
            });
        }

        function goToKioskHome() {
            $state.go("kiosk-home", { slug: $stateParams.slug });
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("forms-widget")
        .service("storageService", storageService);

    /** @ngInject */
    function storageService($window, $log) {
        var service = {};

        service.load = function (key) {
            var value, parsed;
            try {
                value = $window.sessionStorage.getItem(key);
                if (value !== null) {
                    parsed = angular.fromJson(value);
                    $log.debug("'" + key + "' loaded from session storage.", parsed);
                    return parsed;
                }
            } catch (e) {
                $log.debug("Failed to parse '" + key + "' from session storage.", value);
            }
            $log.debug("'" + key + "' not found in session storage.");
        }

        service.save = function (key, value) {
            console.log(value);
            $window.sessionStorage.setItem(key, angular.toJson(value));
            $log.debug("'" + key + "' saved to session storage.")
        }

        service.delete = function (key) {
            $window.sessionStorage.removeItem(key);
            $log.debug("'" + key + "' deleted from session storage.");
        }

        return service;
    }
})();
(function () {
    "use strict";

    angular
        .module("forms-widget")
        .controller("SignedController", SignedController);

    /** @ngInject */
    function SignedController($state, $stateParams, form, isKioskMode) {
        var vm = this;

        vm.isKiosk = isKioskMode;

        if (isKioskMode) {
            vm.goToKioskHome = goToKioskHome;
        }

        activate();

        function activate() {
            vm.bookingAgreementName = form.name ? form.name : "";
            vm.receiptNumber = form.receiptNumber ? form.receiptNumber : "";
        }

        function goToKioskHome() {
            $state.go("kiosk-home", { slug: $stateParams.slug });
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("forms-widget")
        .service("settingsService", settingsService);

    /** @ngInject */
    function settingsService() {
        var service = {};
        var cellId = '';

        service.getCellId = function () { return cellId; }
        service.setCellId = function (id) { cellId = id; }

        return service;
    }
})();
(function () {
    'use strict';

    angular
        .module('forms-widget')
        .directive('poweredByRoller', poweredByRoller);

    /** @ngInject */
    function poweredByRoller(venueService) {
        return {
            restrict: 'E',
            replace: true,
            template: [
                '<div class="text--center" ng-if="!hideRollerBranding()">',
                '<a class="brand--roller" href="http://roller.software" target="_blank">',
                '<span class="brand__text">Powered by</span>',
                '<div class="logo logo--roller logo--roller"></div>',
                '</a>',
                '</div>'
            ].join(''),
            link: function (scope) {
                scope.hideRollerBranding = venueService.hideRollerBranding;
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("forms-widget")
        .controller("KioskController", KioskController);

    /** @ngInject */
    function KioskController($state, $stateParams, $timeout, $scope, formsService) {
        var vm = this;

        vm.search = search;
        vm.completeForm = completeForm;
        vm.receiptNumberChanged = receiptNumberChanged;
        vm.backToStart = backToStart;
        vm.isSearchEnabled = isSearchEnabled;
        vm.isSearching = false;

        function completeForm(formDetail) {
            $state.go("kiosk-forms.form", {
                slug: $stateParams.slug,
                uniqueBookingId: formDetail.uniqueBookingId,
                id: formDetail.formId
            });
        }

        function isSearchEnabled() {
            return !_.isEmpty(vm.receiptNumber);
        }

        function search(isValid) {
            vm.forms = [];

            if (!isValid) {
                return;
            }

            vm.isSearching = true;

            formsService.getFormsRequiringResponse(parseInt(vm.receiptNumber)).then(function (data) {

                if (_.size(data) == 1) {
                    completeForm(data[0]);
                } else {
                    vm.forms = data;
                    vm.noFormRequired = _.isEmpty(vm.forms);
                }
            }, function () {
                $state.go("error");
            }).finally(function(){
                vm.isSearching = false;
            });
        }

        function receiptNumberChanged() {
            vm.noFormRequired = false;
            vm.forms = null;
        }

        function backToStart() {
           $state.go("kiosk-home", {slug: $stateParams.slug}, {reload: true});
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("forms-widget")
        .service("formsService", formsService);

    /** @ngInject */
    function formsService($http, rollerApiUrl, storageService, formRendererService, $state, $q) {
        var service = {};

        var _slug = null;
        var _tickets = null;
        var _productTotalCost = null;
        var _agreementData = {};

        service.slug = function (slug) {

            if (angular.isDefined(slug)) {
                _slug = slug;
            }
            return _slug;
        }

        service.tickets = function () {
            return _tickets;
        }

        service.productTotalCost = function () {
            return _productTotalCost;
        }

        service.agreementData = function () {
            return _agreementData;
        }

        service.getForm = function (slug, id, uniqueBookingId) {
            service.slug(slug);
            _tickets = null;

            // the above concept is on hold for now
            if (uniqueBookingId) {
                return getTheFormAndTicketDetails(id, uniqueBookingId);
            }
            return getTheForm(id);
        }

        var _formSubmissionsClosed = false;
        service.isFormSubmissionClosed = function () {
            return _formSubmissionsClosed;
        }

        function getTheForm(id) {
            _formSubmissionsClosed = false;
            return $http({
                url: rollerApiUrl + 'forms/' + id,
                method: "GET"
            }).then(function (response) {
                var form = response.data;
                if (_.isString(form)) {
                    form = JSON.parse(form);
                }
                return form;
            },
                function (error) {
                    if (error && error.status == 409) {
                        _formSubmissionsClosed = true;
                        $state.go('error');
                    }
                });
        }

        function getTheFormAndTicketDetails(id, uniqueBookingId) {
            _formSubmissionsClosed = false;
            return $http({
                url: rollerApiUrl + 'forms/' + id + '/' + uniqueBookingId,
                method: "GET"
            }).then(function (response) {
                var form = response.data.json;
                if (_.isString(form)) {
                    form = JSON.parse(form);
                }

                form.venueName = response.data.venueName;
                form.bookingHolderName = response.data.bookingHolderName;
                _tickets = response.data.tickets;
                _agreementData = {
                    productTotalCost: response.data.totalCostDisplay,
                    tickets: response.data.tickets,
                    agreementFormResponseDto: response.data.agreementFormResponseDto,
                    showApplicableFees: response.data.showApplicableFees
                };

                return form;
            },
            function (error) {
                if (error && error.status == 409) {
                    _formSubmissionsClosed = true;
                    $state.go('error');
                }
            });
        }

        service.saveFormResponse = function (formResponse, id, uniqueBookingId) {
            var data = {
                id: formResponse.id,
                uniqueBookingId: uniqueBookingId == '0' ? null : uniqueBookingId, // '0' can happen if saveForLaterId is used
                json: angular.toJson(formResponse)
            };
            return $http({
                url: rollerApiUrl + 'forms/response/' + id,
                method: "POST",
                data: data
            }).then(function (response) {
                return response.data;
            });
        }

        service.saveForLater = function (formResponse) {

            var uniqueId = formRendererService.generateRandomId().replace(/-/g, '').substring(0, 15);

            storageService.save(uniqueId, formResponse);

            return '.../#/' + service.slug() + '/' + formResponse.formId + '/0/' + uniqueId;
        }

        service.getSavedFormResponse = function (id) {

            return storageService.load(id);
        }

        service.getFormsRequiringResponse = function (receiptNumber) {

            if (!_.isNumber(receiptNumber)) {
                return $q.when(null);
            }

            return $http.get(rollerApiUrl + 'forms/formsRequiringResponse?receiptNumber=' + receiptNumber).then(_.property("data"));
        }

        service.validateRecaptcha = function (recaptcha) {
            if (recaptcha) {
                return $http.post(rollerApiUrl + 'google/recaptcha/', { response: recaptcha }).then(function (response) {
                    return response.data;
                });
            } else {
                return false;
            }
        }

        return service;
    }
})();

(function () {
    "use strict";

    angular
        .module("forms-widget")
        .controller("FormController", FormController);

    /** @ngInject */
    function FormController($state, $stateParams, form, formsService, formRendererService, uniqueBookingId, $anchorScroll, insideIframe, postMessage, $rootScope, isKioskMode) {
        var vm = this;

        $rootScope.$on('form-renderer-ready', function (info, data) {
            vm.agreementData = formsService.agreementData();
            formRendererService.setAgreementFormInfo(form.id, vm.agreementData);
            formRendererService.setMinTicketDetailsIfApplicable(form.id, formsService.tickets());
            if (vm.agreementData && vm.agreementData.agreementFormResponseDto && vm.agreementData.agreementFormResponseDto.bookingAgreementFormResponseId > 0) {
                vm.form['receiptNumber'] = vm.agreementData.agreementFormResponseDto.receiptNumber;
                $state.go('forms.signed');
            }
        });

        vm.countryRestriction = $rootScope.venue.countryRestriction;
        vm.isReady = $rootScope.venue.isReady;
        vm.form = form;
        vm.isValid = true;
        vm.isKiosk = isKioskMode;
        vm.isSaving = function () {
            return _isSaving;
        }

        var _isSaving = false;
        var _validRecaptcha = false;

        vm.goBack = function () {
            $state.go("kiosk-home", { slug: $stateParams.slug });
        }

        vm.agreementSubmitted = function() {
            if (vm.isKiosk) {
                $state.go('kiosk-forms.submitted');
            } else {
                $state.go('forms.submitted');
            }
        }

        vm.submit = function () {
            vm.isValid = true;
            if (!_isSaving) {
                _isSaving = true;
                var validationResult = formRendererService.validate(form.id, true);
                if (validationResult.isValid && (_validRecaptcha)) {
                    var result = formRendererService.response(form.id);
                    // TODO: maybe pull formResponseId from the API call that gets the ticket details
                    //if (formResponseId) {
                    //    result.id = formResponseId;
                    //}
                    formsService.saveFormResponse(result, vm.form.id, uniqueBookingId).then(function (result) {

                        // when inside an iframe the parent website might want to show a custom
                        // success page, e.g. Scenic World show "Booking Request #" and some other text
                        if (insideIframe) {
                            postMessage("parent", {
                                action: "success",
                                receiptNumber: result ? result.receiptNumber : null
                            });
                        }

                        if (vm.isKiosk) {
                            $state.go('kiosk-forms.submitted');
                        } else {
                            $state.go('forms.submitted');
                        }

                    }, function (error) {
                        _isSaving = false;
                        if (error && error.status == 400) {
                            if (error.data && error.data.message) {
                                alert(error.data.message);
                            }
                            else {
                                alert('One of your fields has invalid input');
                            }
                        }
                    });
                }
                else {
                    _isSaving = false;
                    vm.isValid = false;
                    var errors = _.map(validationResult.errors, function (error) { return error.error; });
                    if (!_validRecaptcha) {
                        errors.push('Recaptcha is required.');
                    }
                    console.log('Form response validation errors - ', errors);
                    $anchorScroll();
                }
            }
        }

        window.recaptchaCallback = function (recaptcha) {
            formsService.validateRecaptcha(recaptcha).then(function (response) {
                _validRecaptcha = response;
            });
        }

        window.recaptchaExpiredCallback = function () {
            _validRecaptcha = false;
        }

        window.recaptchaErrorCallback = function () {
            _validRecaptcha = false;
        }

        window.onloadCallback = function () {
            grecaptcha.render('recaptcha', {
                'sitekey': RollerAppConfig().googleRecaptchaPublicKey,
                'callback': recaptchaCallback,
                'expired-callback': recaptchaExpiredCallback,
                'error-callback': recaptchaErrorCallback
            });
        }
    }
})();

(function () {
  "use strict";

  angular
    .module("forms-widget")
    .config(configureLocale);

  /* @ngInject */
  function configureLocale(tmhDynamicLocaleProvider, env) {
    tmhDynamicLocaleProvider.localeLocationPattern(env.baseUrls.cdn + '/scripts/angular-i18n/' + angular.version.full + '/angular-locale_{{locale}}.js');
  }
}
)();
(function() {
    'use strict';

    angular
        .module('forms-widget')
        .directive('autoFocus', autoFocus);

    autoFocus.$inject = ['$timeout'];
    function autoFocus($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                $timeout(function() {
                    element[0].focus();
                });
            }
        }
    }
})();
(function () {
    "use strict";

    angular
        .module("forms-widget")
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $state, venueService, insideIframe) {
        $rootScope.$on("$stateChangeError", handleStateChangeError);

        function handleStateChangeError() {
            $state.go("error");
        }

        // make available on rootScope so we have easy access to the header image url
        $rootScope.venue = venueService;
        $rootScope.insideIframe = insideIframe;

        // download venue information (e.g. header and background images)
        venueService.probe().then(function () {
            venueService.initialise();
        });
    }

})();

(function () {
    "use strict";

    angular
        .module("forms-widget")
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider, isKioskMode) {
        if (isKioskMode) {
            kioskRoutesSetup($stateProvider, $urlRouterProvider);
        } else {
            defaultRoutesSetup($stateProvider, $urlRouterProvider);
        }

        $stateProvider.state("error", {
            url: "/error",
            templateUrl: "app/main/error.html",
            controller: "WelcomeController as vm"
        });
    }

    function defaultRoutesSetup($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state("forms", {
                abstract: true,
                url: "/{slug}/{id}",
                params: {
                    uniqueBookingId: {
                        squash: true,
                        value: null
                    }
                },
                template: '<ui-view></ui-view>',
                resolve: {
                    slug: function ($stateParams) {
                        'ngInject';
                        return $stateParams.slug;
                    },
                    id: function ($stateParams) {
                        'ngInject';
                        return $stateParams.id;
                    },
                    uniqueBookingId: function ($stateParams) {
                        'ngInject';
                        return $stateParams.uniqueBookingId;
                    },
                    form: function ($stateParams, formsService) {
                        'ngInject';
                        return formsService.getForm($stateParams.slug, $stateParams.id, $stateParams.uniqueBookingId);
                    }
                }
            })
            .state("forms.welcome", {
                url: "",
                templateUrl: "app/main/welcome.html",
                controller: "WelcomeController as vm"
            })
            .state("forms.form", {
                url: ":uniqueBookingId/form",
                templateUrl: "app/main/form.html",
                controller: "FormController as vm"
            })
            .state("forms.submitted", {
                url: "/submitted",
                templateUrl: "app/main/submitted.html",
                controller: "SubmittedController as vm"
            })
            .state("forms.signed", {
                url: "/signed",
                templateUrl: "app/main/signed.html",
                controller: "SignedController as vm"
            });

        $urlRouterProvider.otherwise("");
    }
    
    function kioskRoutesSetup($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state("kiosk-forms", {
                abstract: true,
                url: "/{slug}/kiosk/{id}",
                params: {
                    uniqueBookingId: null
                },
                template: '<ui-view></ui-view>',
                resolve: {
                    slug: function ($stateParams) {
                        'ngInject';
                        return $stateParams.slug;
                    },
                    id: function ($stateParams) {
                        'ngInject';
                        return $stateParams.id;
                    },
                    uniqueBookingId: function ($stateParams) {
                        'ngInject';
                        return $stateParams.uniqueBookingId;
                    },
                    form: function ($stateParams, formsService) {
                        'ngInject';
                        return formsService.getForm($stateParams.slug, $stateParams.id, $stateParams.uniqueBookingId);
                    }
                }
            })
            .state("kiosk-forms.form", {
                url: "/form",
                templateUrl: "app/main/form.html",
                controller: "FormController as vm"
            })
            .state("kiosk-forms.submitted", {
                url: "/submitted",
                templateUrl: "app/main/submitted.html",
                controller: "SubmittedController as vm"
            });

        $stateProvider.state("kiosk-home", {
            url: "/{slug}/kiosk",
            templateUrl: "app/main/kiosk.html",
            controller: "KioskController as vm"
        });

        $urlRouterProvider.otherwise("");

        $urlRouterProvider.when("/{slug}/kiosk/{id}/{uniqueBookingId}", function ($state, $match) {
            $state.transitionTo('kiosk-forms.form', $match)
        });

        $urlRouterProvider.when("/{slug}/kiosk/{id}/{uniqueBookingId}/form", function ($state, $match) {
            $state.transitionTo('kiosk-forms.form', $match)
        });
    }

})();

(function () {
    "use strict";

    // This allows us to map the env settings to the constants expected by this app
    var baseUrls = angular.injector(["roller-env"]).get("env").baseUrls;

    angular.module("forms-widget")
           .constant("apiKey", "")
           .constant("rollerApiUrl", baseUrls.api.replace(/\/?$/, "/"))
           .constant('insideIframe', window.self !== window.top)
           .constant("isKioskMode", window.location.hash.toLowerCase().indexOf("/kiosk") > 0);
})();

(function () {
    "use strict";

    angular
        .module("forms-widget")
        .config(config)
        .factory("HttpRequestInterceptor", httpInterceptor);

    /** @ngInject */
    function config($logProvider, $httpProvider) {
        // Enable log
        $logProvider.debugEnabled(true);
        $httpProvider.interceptors.push("HttpRequestInterceptor");
    }

    /** @ngInject */
    function httpInterceptor($q, $log, $window, settingsService) {
        return {
            request: function (config) {
                config.headers["X-Api-Key"] = $window.location.hash.split('/')[1];

                if (settingsService.getCellId()) {
                    config.headers['X-Cell-Id'] = settingsService.getCellId();
                }

                return config;
            },
            requestError: function (rejection) {
                $log.error(rejection);
                return $q.reject(rejection);
            },
            response: function (response) {
                var headers = response.headers();
                var cellId = headers['X-Cell-Id'] || headers['x-cell-id'];

                if (cellId) {
                    settingsService.setCellId(cellId);
                }
                
                return response;
            },
            responseError: function (rejection) {
                $log.error(rejection);
                return $q.reject(rejection);
            }
        };
    }
})();
angular.module("forms-widget").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/error.html","<div class=\"content-wrapper text--center soft--ends\"><span ng-if=\"!vm.errorText\">An error has occurred, please try reloading the page</span> <span ng-if=\"vm.errorText\">{{ vm.errorText }}</span></div>");
$templateCache.put("app/main/form.html","<div class=\"content-wrapper\" ng-style=\"{\'background\': insideIframe ? \'inherit\' : \'#ffffff\'}\"><div ng-if=\"!vm.form\" class=\"text--center\"><h3>Sorry, this form is no longer accepting responses.</h3></div><div><div class=\"soft--sides\"><div ng-if=\"!vm.isValid\" class=\"state--error soft--sides soft--top\">Please fill in all required fields and the reCAPTCHA box</div><form-renderer ng-if=\"vm.form && venue.localeDataLoaded && vm.countryRestriction() && vm.isReady()\" form=\"vm.form\" form-response=\"vm.formResponse\" options=\"{ countryRestriction: vm.countryRestriction() }\"></form-renderer><div id=\"recaptcha\" class=\"soft--sides\"></div><div class=\"text-center btn-wrapper push--bottom\"><a href=\"\" style=\"float: left;\" ng-if=\"vm.isKiosk\" ng-click=\"vm.goBack()\" class=\"link link--icon\"><span class=\"material-icons md-16\">keyboard_backspace</span> <span class=\"link__text\">Back to start</span></a><div class=\"text--right\"><button ng-click=\"vm.submit()\" class=\"btn--primary btn--large\" ng-disabled=\"vm.isSaving()\">Submit</button></div><div ng-if=\"vm.isSaving()\" class=\"push--ends text--center\"><img src=\"data:image/gif;base64,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\"></div></div></div><powered-by-roller></powered-by-roller></div></div><script src=\"https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit\" async=\"\" defer=\"\"></script>");
$templateCache.put("app/main/kiosk.html","<form name=\"kioskForm\" novalidate=\"\" ng-submit=\"vm.search(kioskForm.$valid)\"><div class=\"content-wrapper\" ng-style=\"{\'background\': insideIframe ? \'inherit\' : \'#ffffff\'}\"><div class=\"soft--top soft--bottom\"><div class=\"soft\"><div class=\"soft--sides\" ng-if=\"!(vm.forms && vm.forms.length > 0)\"><label class=\"alpha push-mid--bottom\">Please enter your booking ID to begin</label><div class=\"cf\"><div class=\"two-thirds float--left\"><div class=\"soft--right\"><input autofocus=\"\" type=\"text\" class=\"input-text one-whole\" name=\"receiptNumber\" id=\"receiptNumber\" required=\"\" pattern=\"\\d+\" ng-model=\"vm.receiptNumber\" maxlength=\"10\" ng-change=\"vm.receiptNumberChanged()\"></div><div ng-messages=\"kioskForm.receiptNumber.$error\" ng-if=\"kioskForm.$submitted\" class=\"push-quarter--top form--error state--error--inv\"><span ng-message=\"required\"><span class=\"material-icons\">warning</span> <span class=\"form--error__message\">Please enter a valid booking ID</span></span> <span ng-message=\"pattern\"><span class=\"material-icons\">warning</span> <span class=\"form--error__message\">Please enter a valid booking ID</span></span></div><p class=\"text--light flush--bottom push-quarter--top text--small\">Your booking ID can be found on your receipt or confirmation email.</p></div><div class=\"one-third float--right\"><button type=\"submit\" class=\"btn--primary btn--large one-whole\" ng-disabled=\"!vm.isSearchEnabled()\">Continue</button></div></div></div><div ng-if=\"vm.isSearching\" class=\"soft\"><div class=\"push--ends text--center\"><img src=\"data:image/gif;base64,R0lGODlhHwAfAPUAAP///wAAAOjo6NLS0ry8vK6urqKiotzc3Li4uJqamuTk5NjY2KqqqqCgoLCwsMzMzPb29qioqNTU1Obm5jY2NiYmJlBQUMTExHBwcJKSklZWVvr6+mhoaEZGRsbGxvj4+EhISDIyMgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAHwAfAAAG/0CAcEgUDAgFA4BiwSQexKh0eEAkrldAZbvlOD5TqYKALWu5XIwnPFwwymY0GsRgAxrwuJwbCi8aAHlYZ3sVdwtRCm8JgVgODwoQAAIXGRpojQwKRGSDCRESYRsGHYZlBFR5AJt2a3kHQlZlERN2QxMRcAiTeaG2QxJ5RnAOv1EOcEdwUMZDD3BIcKzNq3BJcJLUABBwStrNBtjf3GUGBdLfCtadWMzUz6cDxN/IZQMCvdTBcAIAsli0jOHSJeSAqmlhNr0awo7RJ19TJORqdAXVEEVZyjyKtE3Bg3oZE2iK8oeiKkFZGiCaggelSTiA2LhxiZLBSjZjBL2siNBOFQ84LxHA+mYEiRJzBO7ZCQIAIfkECQoAAAAsAAAAAB8AHwAABv9AgHBIFAwIBQPAUCAMBMSodHhAJK5XAPaKOEynCsIWqx0nCIrvcMEwZ90JxkINaMATZXfju9jf82YAIQxRCm14Ww4PChAAEAoPDlsAFRUgHkRiZAkREmoSEXiVlRgfQgeBaXRpo6MOQlZbERN0Qx4drRUcAAJmnrVDBrkVDwNjr8BDGxq5Z2MPyUQZuRgFY6rRABe5FgZjjdm8uRTh2d5b4NkQY0zX5QpjTc/lD2NOx+WSW0++2RJmUGJhmZVsQqgtCE6lqpXGjBchmt50+hQKEAEiht5gUcTIESR9GhlgE9IH0BiTkxrMmWIHDkose9SwcQlHDsOIk9ygiVbl5JgMLuV4HUmypMkTOkEAACH5BAkKAAAALAAAAAAfAB8AAAb/QIBwSBQMCAUDwFAgDATEqHR4QCSuVwD2ijhMpwrCFqsdJwiK73DBMGfdCcZCDWjAE2V347vY3/NmdXNECm14Ww4PChAAEAoPDltlDGlDYmQJERJqEhGHWARUgZVqaWZeAFZbERN0QxOeWwgAAmabrkMSZkZjDrhRkVtHYw+/RA9jSGOkxgpjSWOMxkIQY0rT0wbR2LQV3t4UBcvcF9/eFpdYxdgZ5hUYA73YGxruCbVjt78G7hXFqlhY/fLQwR0HIQdGuUrTz5eQdIc0cfIEwByGD0MKvcGSaFGjR8GyeAPhIUofQGNQSgrB4IsdOCqx7FHDBiYcOQshYjKDxliVDpRjunCjdSTJkiZP6AQBACH5BAkKAAAALAAAAAAfAB8AAAb/QIBwSBQMCAUDwFAgDATEqHR4QCSuVwD2ijhMpwrCFqsdJwiK73DBMGfdCcZCDWjAE2V347vY3/NmdXNECm14Ww4PChAAEAoPDltlDGlDYmQJERJqEhGHWARUgZVqaWZeAFZbERN0QxOeWwgAAmabrkMSZkZjDrhRkVtHYw+/RA9jSGOkxgpjSWOMxkIQY0rT0wbR2I3WBcvczltNxNzIW0693MFYT7bTumNQqlisv7BjswAHo64egFdQAbj0RtOXDQY6VAAUakihN1gSLaJ1IYOGChgXXqEUpQ9ASRlDYhT0xQ4cACJDhqDD5mRKjCAYuArjBmVKDP9+VRljMyMHDwcfuBlBooSCBQwJiqkJAgAh+QQJCgAAACwAAAAAHwAfAAAG/0CAcEgUDAgFA8BQIAwExKh0eEAkrlcA9oo4TKcKwharHScIiu9wwTBn3QnGQg1owBNld+O72N/zZnVzRApteFsODwoQABAKDw5bZQxpQ2JkCRESahIRh1gEVIGVamlmXgBWWxETdEMTnlsIAAJmm65DEmZGYw64UZFbR2MPv0QPY0hjpMYKY0ljjMZCEGNK09MG0diN1gXL3M5bTcTcyFtOvdzBWE+207pjUKpYrL+wY7MAB4EerqZjUAG4lKVCBwMbvnT6dCXUkEIFK0jUkOECFEeQJF2hFKUPAIkgQwIaI+hLiJAoR27Zo4YBCJQgVW4cpMYDBpgVZKL59cEBhw+U+QROQ4bBAoUlTZ7QCQIAIfkECQoAAAAsAAAAAB8AHwAABv9AgHBIFAwIBQPAUCAMBMSodHhAJK5XAPaKOEynCsIWqx0nCIrvcMEwZ90JxkINaMATZXfju9jf82Z1c0QKbXhbDg8KEAAQCg8OW2UMaUNiZAkREmoSEYdYBFSBlWppZl4AVlsRE3RDE55bCAACZpuuQxJmRmMOuFGRW0djD79ED2NIY6TGCmNJY4zGQhBjStPTFBXb21DY1VsGFtzbF9gAzlsFGOQVGefIW2LtGhvYwVgDD+0V17+6Y6BwaNfBwy9YY2YBcMAPnStTY1B9YMdNiyZOngCFGuIBxDZAiRY1eoTvE6UoDEIAGrNSUoNBUuzAaYlljxo2M+HIeXiJpRsRNMaq+JSFCpsRJEqYOPH2JQgAIfkECQoAAAAsAAAAAB8AHwAABv9AgHBIFAwIBQPAUCAMBMSodHhAJK5XAPaKOEynCsIWqx0nCIrvcMEwZ90JxkINaMATZXfjywjlzX9jdXNEHiAVFX8ODwoQABAKDw5bZQxpQh8YiIhaERJqEhF4WwRDDpubAJdqaWZeAByoFR0edEMTolsIAA+yFUq2QxJmAgmyGhvBRJNbA5qoGcpED2MEFrIX0kMKYwUUslDaj2PA4soGY47iEOQFY6vS3FtNYw/m1KQDYw7mzFhPZj5JGzYGipUtESYowzVmF4ADgOCBCZTgFQAxZBJ4AiXqT6ltbUZhWdToUSR/Ii1FWbDnDkUyDQhJsQPn5ZU9atjUhCPHVhgTNy/RSKsiqKFFbUaQKGHiJNyXIAAh+QQJCgAAACwAAAAAHwAfAAAG/0CAcEh8JDAWCsBQIAwExKhU+HFwKlgsIMHlIg7TqQeTLW+7XYIiPGSAymY0mrFgA0LwuLzbCC/6eVlnewkADXVECgxcAGUaGRdQEAoPDmhnDGtDBJcVHQYbYRIRhWgEQwd7AB52AGt7YAAIchETrUITpGgIAAJ7ErdDEnsCA3IOwUSWaAOcaA/JQ0amBXKa0QpyBQZyENFCEHIG39HcaN7f4WhM1uTZaE1y0N/TacZoyN/LXU+/0cNyoMxCUytYLjm8AKSS46rVKzmxADhjlCACMFGkBiU4NUQRxS4OHijwNqnSJS6ZovzRyJAQo0NhGrgs5bIPmwWLCLHsQsfhxBWTe9QkOzCwC8sv5Ho127akyRM7QQAAOwAAAAAAAAAAADxiciAvPgo8Yj5XYXJuaW5nPC9iPjogIG15c3FsX3F1ZXJ5KCkgWzxhIGhyZWY9J2Z1bmN0aW9uLm15c3FsLXF1ZXJ5Jz5mdW5jdGlvbi5teXNxbC1xdWVyeTwvYT5dOiBDYW4ndCBjb25uZWN0IHRvIGxvY2FsIE15U1FMIHNlcnZlciB0aHJvdWdoIHNvY2tldCAnL3Zhci9ydW4vbXlzcWxkL215c3FsZC5zb2NrJyAoMikgaW4gPGI+L2hvbWUvYWpheGxvYWQvd3d3L2xpYnJhaXJpZXMvY2xhc3MubXlzcWwucGhwPC9iPiBvbiBsaW5lIDxiPjY4PC9iPjxiciAvPgo8YnIgLz4KPGI+V2FybmluZzwvYj46ICBteXNxbF9xdWVyeSgpIFs8YSBocmVmPSdmdW5jdGlvbi5teXNxbC1xdWVyeSc+ZnVuY3Rpb24ubXlzcWwtcXVlcnk8L2E+XTogQSBsaW5rIHRvIHRoZSBzZXJ2ZXIgY291bGQgbm90IGJlIGVzdGFibGlzaGVkIGluIDxiPi9ob21lL2FqYXhsb2FkL3d3dy9saWJyYWlyaWVzL2NsYXNzLm15c3FsLnBocDwvYj4gb24gbGluZSA8Yj42ODwvYj48YnIgLz4KPGJyIC8+CjxiPldhcm5pbmc8L2I+OiAgbXlzcWxfcXVlcnkoKSBbPGEgaHJlZj0nZnVuY3Rpb24ubXlzcWwtcXVlcnknPmZ1bmN0aW9uLm15c3FsLXF1ZXJ5PC9hPl06IENhbid0IGNvbm5lY3QgdG8gbG9jYWwgTXlTUUwgc2VydmVyIHRocm91Z2ggc29ja2V0ICcvdmFyL3J1bi9teXNxbGQvbXlzcWxkLnNvY2snICgyKSBpbiA8Yj4vaG9tZS9hamF4bG9hZC93d3cvbGlicmFpcmllcy9jbGFzcy5teXNxbC5waHA8L2I+IG9uIGxpbmUgPGI+Njg8L2I+PGJyIC8+CjxiciAvPgo8Yj5XYXJuaW5nPC9iPjogIG15c3FsX3F1ZXJ5KCkgWzxhIGhyZWY9J2Z1bmN0aW9uLm15c3FsLXF1ZXJ5Jz5mdW5jdGlvbi5teXNxbC1xdWVyeTwvYT5dOiBBIGxpbmsgdG8gdGhlIHNlcnZlciBjb3VsZCBub3QgYmUgZXN0YWJsaXNoZWQgaW4gPGI+L2hvbWUvYWpheGxvYWQvd3d3L2xpYnJhaXJpZXMvY2xhc3MubXlzcWwucGhwPC9iPiBvbiBsaW5lIDxiPjY4PC9iPjxiciAvPgo8YnIgLz4KPGI+V2FybmluZzwvYj46ICBteXNxbF9xdWVyeSgpIFs8YSBocmVmPSdmdW5jdGlvbi5teXNxbC1xdWVyeSc+ZnVuY3Rpb24ubXlzcWwtcXVlcnk8L2E+XTogQ2FuJ3QgY29ubmVjdCB0byBsb2NhbCBNeVNRTCBzZXJ2ZXIgdGhyb3VnaCBzb2NrZXQgJy92YXIvcnVuL215c3FsZC9teXNxbGQuc29jaycgKDIpIGluIDxiPi9ob21lL2FqYXhsb2FkL3d3dy9saWJyYWlyaWVzL2NsYXNzLm15c3FsLnBocDwvYj4gb24gbGluZSA8Yj42ODwvYj48YnIgLz4KPGJyIC8+CjxiPldhcm5pbmc8L2I+OiAgbXlzcWxfcXVlcnkoKSBbPGEgaHJlZj0nZnVuY3Rpb24ubXlzcWwtcXVlcnknPmZ1bmN0aW9uLm15c3FsLXF1ZXJ5PC9hPl06IEEgbGluayB0byB0aGUgc2VydmVyIGNvdWxkIG5vdCBiZSBlc3RhYmxpc2hlZCBpbiA8Yj4vaG9tZS9hamF4bG9hZC93d3cvbGlicmFpcmllcy9jbGFzcy5teXNxbC5waHA8L2I+IG9uIGxpbmUgPGI+Njg8L2I+PGJyIC8+Cg==\"></div></div><div class=\"soft--sides\"><p ng-if=\"vm.noFormRequired\" class=\"flush--bottom push--top text--light\">No forms are required for booking <strong>{{vm.receiptNumber}}</strong>.</p><div ng-if=\"vm.forms && vm.forms.length > 0\" class=\"soft--sides\"><h1 class=\"alpha push-half--bottom\">Please select a form</h1><div ng-repeat=\"f in vm.forms\"><h2 class=\"beta push-quarter--bottom\"><a href=\"javascript:void(0)\" class=\"link\" ng-click=\"vm.completeForm(f)\">{{f.formName}}</a></h2><p class=\"text--light\" ng-bind-html=\"f.formDescription\"></p></div><a href=\"javascript:void(0)\" class=\"link link--icon\" ng-click=\"vm.backToStart()\"><span class=\"material-icons md-16\">keyboard_backspace</span> <span class=\"link__text\">Back to start</span></a></div></div></div></div><powered-by-roller></powered-by-roller></div></form>");
$templateCache.put("app/main/signed.html","<div class=\"content-wrapper soft--top\"><div class=\"soft--sides\"><div class=\"soft\"><h1 class=\"alpha text--icon push-half--bottom\" ng-if=\"!vm.postSubmissionPage\" style=\"display: flex\"><span class=\"material-icons state--success push-quarter--right\">check_circle</span> <span class=\"text\">You\'re all set!<br>{{vm.bookingAgreementName}} has already been completed for your booking {{vm.receiptNumber}}</span></h1></div><div ng-if=\"vm.postSubmissionPage\" class=\"soft--sides\"><p ng-bind-html=\"vm.postSubmissionPage.contentHtml\"></p></div><div ng-if=\"vm.isKiosk\" class=\"text--right btn-wrapper push--top soft--top\"><button ng-click=\"vm.goToKioskHome()\" class=\"btn--primary btn--large\">New form</button></div></div><powered-by-roller></powered-by-roller></div>");
$templateCache.put("app/main/submitted.html","<div class=\"content-wrapper soft--top\"><div class=\"soft--sides\"><div class=\"soft\"><h1 class=\"alpha text--icon push-half--bottom\" ng-if=\"!vm.postSubmissionPage\"><span class=\"material-icons state--success push-quarter--right\">check_circle</span> <span class=\"text\">Thank you! Your form has been submitted.</span></h1></div><div ng-if=\"vm.postSubmissionPage\" class=\"soft--sides\"><p ng-bind-html=\"vm.postSubmissionPage.contentHtml\"></p></div><div ng-if=\"vm.isKiosk\" class=\"text--right btn-wrapper push--top soft--top\"><button ng-click=\"vm.goToKioskHome()\" class=\"btn--primary btn--large\">New form</button></div></div><powered-by-roller></powered-by-roller></div>");
$templateCache.put("app/main/welcome.html","<div style=\"text-align:center\"><h4>Welcome to the form widget</h4><button ng-click=\"vm.goToForm()\" class=\"btn btn--light-grey\">Go to the form</button></div>");}]);